export const retrieve = (key) => {
  if (!key) return undefined
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch (e) {
    return undefined
  }
}

export const store = (key, value) => {
  if (!key) return
  try {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      localStorage.removeItem(key)
    }
  } catch (error) {}
}

const sessionCache = {}

export const retrieveSession = (key) => {
  if (!key) return undefined

  if (sessionCache[key]) {
    return sessionCache[key]
  }

  try {
    const value = JSON.parse(sessionStorage.getItem(key))

    sessionCache[key] = value

    return value
  } catch (e) {
    return undefined
  }
}

export const storeSession = (key, value) => {
  if (!key) return
  try {
    if (value) {
      sessionStorage.setItem(key, JSON.stringify(value))
    } else {
      sessionStorage.removeItem(key)
    }
  } catch (error) {}
}
